<app-admin-navigation *ngIf="showAdminShell()"></app-admin-navigation>
<div class="admin-workspace" [class.authenticated]="showAdminShell()">
  <app-admin-topbar *ngIf="showAdminShell()"></app-admin-topbar>
  <div class="route-stage" [class.route-stage-loading]="showAdminShell() && routeLoading.visible()">
    <app-route-skeleton
      *ngIf="showAdminShell() && routeLoading.visible()"
      class="global-route-skeleton"
      [variant]="skeletonVariant()"
    ></app-route-skeleton>
    <router-outlet></router-outlet>
  </div>
</div>
<app-feedback-center></app-feedback-center>

<!-- Kubo: asistente siempre visible en el panel (avisos, novedades,
     progreso y reacciones). Uno solo para todo el panel. -->
<app-kubo-dock *ngIf="showAdminShell()" mode="global"></app-kubo-dock>

<!-- Acceso pausado (prueba vencida / plan restringido): acciones directas
     para pagar o contratar + contactos de la plataforma. Solo propietarios
     reciben la pantalla de suscripción (los empleados no pueden pagar). -->
<app-access-blocked *ngIf="showAdminShell() && auth.trialExpired()" mode="trial">
  <ng-container *ngIf="isOwner()">
    <div abActions>
      <button type="button" class="ab-btn ab-btn-primary" (click)="scrollToPlanChoice()"><i class="bi bi-stars" aria-hidden="true"></i> Elegir un plan</button>
    </div>
    <app-suscripcion></app-suscripcion>
  </ng-container>
</app-access-blocked>

<app-access-blocked *ngIf="showAdminShell() && auth.subscriptionRestricted() && !auth.trialExpired()" mode="restricted">
  <ng-container *ngIf="isOwner()">
    <div abActions>
      <button type="button" class="ab-btn ab-btn-primary" (click)="restrictedSub.openRenewalPayment()" [disabled]="!restrictedSub.currentPlan()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i> Renovar mi plan</button>
      <button type="button" class="ab-btn" (click)="scrollToPlanChoice()"><i class="bi bi-grid" aria-hidden="true"></i> Ver otros planes</button>
    </div>
    <app-suscripcion #restrictedSub></app-suscripcion>
  </ng-container>
</app-access-blocked>
